export default {
    key: 'eigerrun',
    common: {
        productName: 'core.productNames.eigerrun',
        splashMessage: 'offerFlow.splashMessage.eigerrun',
        headingAside: 'offerFlow.headingAside.eigerrun',
    },
    stepDate: {
        heading: 'offerFlow.pages.stepDate.heading.eigerrun',
    },
    stepPassengers: {
        heading: 'offerFlow.pages.stepPassengers.heading.activity',
        body: 'offerFlow.pages.stepPassengers.body.common',
    },
} satisfies OfferFlowContent;
